import { Stack, Typography } from '@mui/material';

import { ConnectedAccount, useConnectedAccounts } from '@/api/userAccount';
import { ConnectedAccountDisplay } from '@/components/userAccount/ConnectedAccountDisplay';

export const ConnectedAccountsSection = () => {
    const { data: connectedAccounts } = useConnectedAccounts();

    if (!connectedAccounts || !connectedAccounts.length) {
        return null;
    }

    return (
        <Stack gap={2} data-testid="connected-accounts-section">
            <Typography variant="h4">Connected Accounts</Typography>
            {connectedAccounts.map((connectedAccount: ConnectedAccount) => (
                <ConnectedAccountDisplay connectedAccount={connectedAccount} key="" />
            ))}
        </Stack>
    );
};
